/** @jsx h */
//@flow
import { Fragment, h } from 'preact';
import { useState, useEffect, useRef } from 'preact/compat';
import style from './style.css';
import { connect } from 'react-redux';
import SpinLoader from '../../../../spinLoader';
import { visibilityTimeUntilRedirect } from './constant';
import { tracker, UserActionType } from '../../../../../tracking';
import { route } from 'preact-router';
import { posCustomerPaymentFailureRoute } from '../../../../../alias/paymentRoutes';
import Utils from '../../../../../utils';

type Props = {
  helpText: String,
  title: String,
  message: String,
  cta: String,
  errorType: String,
  pageKey: String,
  returnUrl: String,
  pgData: Object,
  closeModal: Function,
  sourceRef: String,
};

const clickTracking = (
  pageKey = 'Missing PageKey',
  elementName = 'Missing ElementName',
  additionalProperties,
) => {
  tracker.trackUserInteraction(
    UserActionType.CLICK,
    elementName,
    pageKey,
    additionalProperties,
  );
};

const TransactionErrorBlockBody = (props: Props) => {
  const {
    helpText,
    title,
    message,
    cta,
    errorType,
    pageKey,
    closeModal,
    pgData,
    returnUrl,
    metadata,
    channel,
    sourceRef,
    merchantName,
  } = props || {};

  const interval = useRef();

  const isOfflineMobileDevice = () => {
    return channel && channel === 'OFFLINE' && !sourceRef;
  };

  const [redirectTimer, setRedirectTimer] = useState(
    visibilityTimeUntilRedirect,
  );

  useEffect(() => {
    interval.current = setInterval(() => {
      setRedirectTimer((seconds) => (seconds ? seconds - 1 : 0));
    }, 1000);

    return () => {
      clearInterval(interval.current);
    };
  }, []);

  const handleTxnRedirection = () => {
    if (channel && (channel === 'OFFLINE' || channel === 'PAYMENT_LINK')) {
      closeModal();
      route(`${posCustomerPaymentFailureRoute.path}`, true);
      return;
    }
    if (returnUrl) {
      const utils = new Utils();
      utils.createAndSubmitDynamicForm(pgData, returnUrl);
    } else {
      closeModal();
    }
  };

  const handleButton = () => {
    clickTracking(pageKey, 'Error', {
      ...(errorType && { error_type: errorType }),
      ...(message && { error_message: message }),
      ...(title && { error_title: title }),
      ...metadata,
    });
    handleTxnRedirection();
  };

  useEffect(() => {
    if (redirectTimer === 0) {
      handleTxnRedirection();
      clearInterval(interval.current);
      closeModal();
    }
  }, [redirectTimer]);

  return (
    <Fragment>
      {title && (
        <div className={style.headerContainer}>
          <div
            className='font20 text80 bold-text text-center'
            id='transactionErrorPopupTitle'>
            {title}
          </div>
        </div>
      )}
      {message && (
        <p className='font14 text60' id='transactionErrorPopupMessage'>
          {channel === 'PAYMENT_LINK' && errorType === 'Eligibility'
            ? 'Transaction has been canceled'
            : message}
        </p>
      )}

      {!isOfflineMobileDevice() && cta && channel !== 'PAYMENT_LINK' && (
        <div className={style.buttonWrapper}>
          <button
            className={style.goBackButton}
            onClick={handleButton}
            id='transactionErrorPopupBackBtn'>
            {cta}
          </button>
        </div>
      )}
      {helpText && (
        <div
          className={`font12 text-center text60 ${style.helperText}`}
          id='transactionErrorPopupHelperText'>
          {channel === 'PAYMENT_LINK' && errorType === 'Eligibility'
            ? `Restart your payment from ${
                merchantName ? merchantName : 'the merchant'
              }`
            : helpText}
        </div>
      )}
      <div className={`${style.redirect__wrapper} block__modal--loader`}>
        <div
          className={style.loader}
          id='transactionErrorPopupRedirectTimeLoader'>
          <SpinLoader size='xsmall' />
        </div>
        <span className={style.redirect__text}>
          Redirecting in{' '}
          <span className={style.timer} id='transactionErrorPopupRedirectTime'>
            {redirectTimer} second{redirectTimer > 1 ? 's' : ''}
          </span>
        </span>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  modal,
  config,
  paymentDetails,
  paymentUserData,
}) => {
  const { pgData, returnUrl } = paymentUserData || {};

  const { errorBlockTransaction } = modal || {};
  const { helpText, title, message, cta, errorType } =
    errorBlockTransaction || {};
  const { pageKey, metadata, sourceRef } = config;
  const { channel, merchantName } = paymentDetails || {};

  return {
    helpText,
    title,
    message,
    cta,
    errorType,
    pageKey,
    pgData,
    returnUrl,
    metadata,
    channel,
    sourceRef,
    merchantName,
  };
};

export default connect(mapStateToProps)(TransactionErrorBlockBody);



// WEBPACK FOOTER //
// ./components/partial/layers/modals/errorBlockTransactionModal/transactionErrorBlockBody.js